import { post } from '../utility';

//- Carrier station mappings: text on a carrier's bill (usually the street address) that means
//- one of our stations. Used when a freight bill stop has no station code on it.

export const search = ({ carrierId, callback }) => {
	post({
		method: 'carrierStationMapping.search',
		params: carrierId ? { carrierId } : {},
		callback,
	});
};

export const add = ({ carrierId, matchText, stationId, notes, callback }) => {
	post({
		method: 'carrierStationMapping.add',
		params: { carrierId, matchText, stationId, notes },
		callback,
	});
};

export const update = ({ carrierStationMappingId, matchText, stationId, notes, callback }) => {
	post({
		method: 'carrierStationMapping.update',
		params: { carrierStationMappingId, matchText, stationId, notes },
		callback,
	});
};

export const remove = ({ carrierStationMappingId, callback }) => {
	post({
		method: 'carrierStationMapping.remove',
		params: { carrierStationMappingId },
		callback,
	});
};

//- Same folding the backend matches with (carrierStationMapping.normalizeText), so the dialog
//- can warn when the text will not match the destination it was opened from.
const WORD_ALIASES = {
	STREET: 'ST',
	AVENUE: 'AVE',
	AV: 'AVE',
	ROAD: 'RD',
	DRIVE: 'DR',
	BOULEVARD: 'BLVD',
	LANE: 'LN',
	PARKWAY: 'PKWY',
	HIGHWAY: 'HWY',
	EXPRESSWAY: 'EXPY',
	EXPWY: 'EXPY',
	EAST: 'E',
	WEST: 'W',
	NORTH: 'N',
	SOUTH: 'S',
};

export const normalizeText = (text) =>
	String(text || '')
		.toUpperCase()
		.replace(/[^A-Z0-9]+/g, ' ')
		.split(' ')
		.filter((word) => word)
		.map((word) => (/\d/.test(word) ? word.replace(/O/g, '0') : word))
		.map((word) => WORD_ALIASES[word] || word)
		.join(' ');

export const textAppearsIn = ({ matchText, destination }) =>
	` ${normalizeText(destination)} `.includes(` ${normalizeText(matchText)} `);

/**
 * A starting point for the text to match on: the street address in the destination
 * ("3403 W ASHLAN" out of "FUEL UP VALENTINE ... 3403 W ASHLAN AVE Fresno"). Carrier store
 * numbers ("#90412") are skipped. Falls back to the whole destination when no address is
 * found ("GREENFIELD MARKET - 76 BRANDED").
 */
export const suggestMatchText = (destination) => {
	const words = String(destination || '')
		.trim()
		.split(/\s+/);
	for (let i = 0; i < words.length - 2; i += 1) {
		if (
			/^\d{2,6}$/.test(words[i]) &&
			/^[A-Z]/i.test(words[i + 1]) &&
			/^[A-Z]/i.test(words[i + 2])
		) {
			return words.slice(i, i + 3).join(' ');
		}
	}
	return String(destination || '').trim();
};
